import React from "react";
import ControlPanel from "./ControlPanel";
import useModeColor from "../../hooks/useModeColor";
import ToggleIconLink from "../../Components/ToggleIconLink";
import { IControlSound } from "./types";

interface IControlSoundProps {
  control: IControlSound;
}

const ControlSound = (props: IControlSoundProps) => {
  const { control } = props;
  const mode = control.is_enabled ? "on" : "disabled";
  const iconColor = useModeColor(mode);

  return (
    <ControlPanel id={control.id} mode={mode} title={control.name} state="">
      <ToggleIconLink
        to={`/controls/details/${control.id}`}
        name="audio-input-stereo-minijack"
        color={iconColor}
      />
    </ControlPanel>
  );
};

export default ControlSound;
